import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Spin,
  Upload,
  UploadFile,
  UploadProps,
} from 'antd';
import { DashBoardApiService } from 'features/Dashboard/api/dashboard-api.service';
// import { useUploadImage } from 'features/Dashboard/use-cases/upload-image';
import { DocumentsApiService } from 'features/document-report/api/documents-api.service';
import { useDropDownFlag } from 'features/document-report/use-cases/drop-down';
import { useCreateUploadUnivresalLink } from 'features/document-report/use-cases/upload-universal-link';
import { useUserContext } from 'features/users';
import { Fragment, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { convertFileSize, validateFileBeforeUpload } from 'routes/utils';

export const ItemUniversalLink = ({ data, year, month }: any) => {
  const formName = 'add-user-form';
  const { user, companyUser } = useUserContext();
  const params = useParams();
  const { id, clientid, uniqueid } = params;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { mutate, isLoading } = useCreateUploadUnivresalLink();
  const [subCategoryValue, setSubCategoryValue] = useState('');
  const [subClassValue, setSubClassValue] = useState<any>('');
  const [fileList, setFileList] = useState<any[]>([]);
  const [previewImage, setPreviewImage] = useState<string>('');
  const [previewOpen, setPreviewOpen] = useState<boolean>(false);
  const [finishedData, setFinishedData] = useState<any>('');
  const [fileNames, setFileNames] = useState<string[]>([]);
  const [isImageUploading, setIsImageUploading] = useState<boolean>(false); // Loading state for image upload
  const [blobUrls, setBlobUrls] = useState<string[]>([]);

  const StorageToken = localStorage.getItem(
    'partnerplus_coustomer__access_token',
  );
  const { data: subCategory, refetch } = useDropDownFlag(
    'SubCategory',
    `${subCategoryValue}&CompanyId=${id}&ClientId=${clientid}`,
  );
  const handlePreview = async (file: UploadFile, index: number) => {
    // Use the blob URL for previewing the specific file
    setPreviewImage(blobUrls[index] || (file.preview as string));
    setPreviewOpen(true);
  };
  const getAllCompanyIds = () => {
    // Check if `companyUser` and `rc` array exist
    if (companyUser?.rc?.length > 0) {
      // Map through the `rc` array to extract all `CompanyId` values
      return companyUser.rc.map((item: any) => item.CompanyId);
    }

    return [];
  };
  const companyIds = getAllCompanyIds();

  const initialFinished = async () => {
    try {
      const payload = {
        companyId: id,
        year: +year,
        month: +month,
      };
      const apires = await DocumentsApiService().getMarkFinishedUniversal(
        payload,
      );
      setFinishedData(apires);
    } catch (error: any) {
      message.error(error);
    }
  };
  // const handleImageUpload = (file: UploadFile) => {
  //   const formData = new FormData();
  //   formData.append('file', file as any);

  //   setIsImageUploading(true);

  //   uploadImage(
  //     { id: id as string, formData }, // Pass id and file as payload
  //     {
  //       onSuccess: (response: any) => {
  //         // setBlobUrl(response?.blobUrl); // Save blob URL
  //         setFileNames((prev: any) => [...prev, response.fileName]);
  //         message.success('File uploaded successfully');
  //         setIsImageUploading(false); // Reset uploading state
  //       },
  //       onError: (error: any) => {
  //         message.error('Image upload failed');
  //         console.error('Image upload failed, error:', error);
  //         setIsImageUploading(false); // Reset uploading state
  //       },
  //     },
  //   );
  // };
  const handleImageUpload = async (file: UploadFile) => {
    const formData = new FormData();
    formData.append('file', file as any);
    setIsImageUploading(true);

    try {
      // API call to upload the image with separate arguments
      const response = await DashBoardApiService().uploadImageDocument(
        user?.CompanyId as string, // Pass the id as the first argument
        formData, // Pass the formData as the second argument
      );
      // Assuming the response contains a fileName
      setFileNames((prev: any) => [...prev, response.fileName]);
      setBlobUrls((prev) => [...prev, response.blobUrl]); // Store the blob URL for each file
      message.success('File uploaded successfully');
    } catch (error) {
      message.error('Image upload failed');
    } finally {
      setIsImageUploading(false);
    }
  };

  const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) =>
    setFileList(newFileList);
  // const handleUpdate = (formValues: any) => {
  //   const formData = new FormData();
  //   formData.append('DocumentName', formValues.DocumentName);
  //   formData.append('CompanyId', id as any);
  //   formData.append('UniqueId', uniqueid as any);
  //   formData.append('ClientId', clientid as any);
  //   formData.append('Month', month);
  //   formData.append('Year', year);
  //   formData.append('IsClientUpload', true as any);
  //   let serviceId = formValues.class;
  //   if (formValues.category && formValues.SubCategory) {
  //     serviceId = formValues.SubCategory;
  //   } else if (formValues.category) {
  //     serviceId = formValues.category;
  //   }
  //   formData.append('ServiceId', serviceId);
  //   if (formValues.category && formValues.SubCategory && formValues.class) {
  //     serviceId = formValues.class;
  //   }
  //   fileList.forEach((fileItem: any) => {
  //     const file1 = fileItem.originFileObj;
  //     if (file1) {
  //       formData.append('file', file1);
  //       formData.append('FileName', file1.name);
  //     }
  //   });
  //   mutate(formData, {
  //     onSuccess: (data1: any) => {
  //       if (data1.rs == 0) {
  //         message.error(data1?.rm);
  //       } else {
  //         message.success('Document Upload Successfully');
  //         setTimeout(() => {
  //           navigate('/login');
  //         }, 1000);
  //       }
  //     },
  //   });
  // };
  const handleUpdate = (formValues: any) => {
    const IsClientUpload = true;

    // Check if fileList is empty
    if (!fileList || fileList.length === 0) {
      message.error('Please upload at least one file.');

      return;
    }

    // Process files
    const files = fileList
      .map((fileItem, index) => {
        const file = fileItem.originFileObj;

        if (!file) return null; // Skip if file is missing

        const fileSize = file.size;
        const documentName =
          fileList.length > 1
            ? `${formValues.DocumentName || 'Document'} (${index + 1})`
            : formValues.DocumentName || 'Document'; // No index if there's only one file

        return {
          documentName,
          fileName: fileNames[index] || '',
          fileSize: convertFileSize(fileSize),
        };
      })
      .filter((file) => file !== null);

    // Construct payload
    const payload: any = {
      companyId: id,
      uniqueId: uniqueid,
      periodId: 0,
      serviceId:
        formValues.class || formValues.SubCategory || formValues.category || 0,
      isClientUpload: IsClientUpload,
      files,
      year: +year,
      month: +month,
    };

    // Call API and handle response
    mutate(payload, {
      onSuccess: (data1: any) => {
        if (data1.rs === 0) {
          message.error(data1?.rm);
        } else {
          message.success('Document Upload Successfully');

          // Reset form fields
          form.resetFields();

          // Clear file list
          setFileList([]);

          // Optionally clear fileNames if used
          setFileNames([]);
        }
      },
      onError: () => {
        message.error('Failed to upload document. Please try again.');
      },
    });
  };

  const beforeUpload = (file: any) => {
    // Validate file before upload
    const isValid = validateFileBeforeUpload(file);

    if (isValid) {
      handleImageUpload(file); // Call handleImageUpload only if valid
    }

    return isValid; // If false, upload will be prevented
  };
  const initialValues = async () => {
    try {
      const apires: any = await DocumentsApiService().dropDownByClassFlag({
        Flag: 'Class',
        ParentId: subClassValue,
        CompanyId: user?.CompanyId,
        ClientId: user?.Id,
      });
      setSubClassValue(apires);
    } catch (error: any) {
      message.error(error);
    }
  };
  useEffect(() => {
    if (subClassValue) {
      initialValues();
    }
  }, [subClassValue]);

  useEffect(() => {
    if (subCategoryValue) {
      refetch();
    }
  }, [subCategoryValue, refetch]);

  useEffect(() => {
    // const { id, clientid, uniqueid } = params;
    initialFinished();
    if (!StorageToken) {
      navigate(
        `/login?returnUrl=universaldocuments/${id}/${clientid}/${uniqueid}`,
      );
    }
  }, [params, StorageToken, navigate]);

  return (
    <Fragment>
      {companyIds.includes(id) ? (
        <Form
          id={formName}
          name={formName}
          form={form}
          layout='vertical'
          onFinish={handleUpdate}
        >
          <Form.Item
            name={'DocumentName'}
            label={'Document Name'}
            rules={[
              {
                required: true,
                whitespace: false,
              },
            ]}
          >
            <Input placeholder={'Enter Document Name'} />
          </Form.Item>
          <Form.Item label='Category' name={'category'}>
            <Select
              options={data?.rc?.map((item: any) => ({
                label: item.text,
                value: item.value,
              }))}
              onChange={(value) => setSubCategoryValue(value)}
              placeholder='Please Select'
            />
          </Form.Item>
          {subCategoryValue && (
            <Form.Item name={'SubCategory'} label={'Sub Category'}>
              <Select
                options={subCategory?.data.rc?.map((item: any) => ({
                  label: item.text,
                  value: item.value,
                }))}
                onChange={(value) => setSubClassValue(value)}
                placeholder='Please Select'
              />
            </Form.Item>
          )}
          {subClassValue?.data?.rc.length > 0 && (
            <Form.Item name={'class'} label={'Class'}>
              <Select
                options={subClassValue?.data?.rc.map((item: any) => ({
                  label: item.text,
                  value: item.value,
                }))}
                placeholder='Please Select'
              />
            </Form.Item>
          )}
          <Form.Item
            label='Upload Documents'
            name='files' // Use plural if multiple files
          >
            <div className='upld_item mltybs'>
              <Upload
                action='https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload'
                listType='picture-card'
                fileList={fileList}
                style={{ color: '#223666', fill: '#223666' }}
                onPreview={(file) =>
                  handlePreview(file, fileList.indexOf(file))
                }
                onChange={handleChange}
                multiple // Allow multiple files
                maxCount={50} // Set maximum number of files if needed
                accept='.png,.jpeg,.jpg,.webp,.csv,.xlsx,.xls,.pdf' // Allowed file types
                beforeUpload={beforeUpload}
              >
                {fileList?.length >= 50 ? null : (
                  <div className='upld_img'>
                    <img src='/upload-img.png' alt='Upload icon' />
                    <p className='drp_text'>
                      Drag and drop here <span>or</span>{' '}
                      <a href='javascript:void(0)'>Browse Files</a>
                    </p>
                  </div>
                )}
              </Upload>
              {fileList.length > 0 && (
                <div style={{ width: '100%', marginTop: '10px' }}>
                  {fileList.map((file: UploadFile, index: any) => (
                    <Row
                      key={file.uid}
                      align='middle'
                      justify='space-between'
                      style={{
                        marginBottom: '10px',
                        padding: '8px',
                        background: '#f5f5f5',
                        borderRadius: '8px',
                      }}
                    >
                      <Col span={16}>
                        <div>{file.name}</div>
                      </Col>
                      <Col span={8} style={{ textAlign: 'right' }}>
                        <Button
                          type='primary'
                          onClick={() => handlePreview(file, index)}
                          style={{
                            backgroundColor: '#4CAF50',
                            color: 'white',
                            marginLeft: '8px',
                            borderRadius: '8px',
                          }}
                        >
                          Preview
                        </Button>
                      </Col>
                    </Row>
                  ))}
                </div>
              )}
              {isImageUploading && (
                <div
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1,
                  }}
                >
                  <Spin size='large' />
                </div>
              )}
            </div>
            {/* {previewImage && (
              <Image
                wrapperStyle={{ display: 'none' }}
                preview={{
                  visible: previewOpen,
                  onVisibleChange: (visible) => setPreviewOpen(visible),
                  afterOpenChange: (visible) => !visible && setPreviewImage(''),
                }}
                src={previewImage}
              />
            )} */}
            <Modal
              open={previewOpen}
              onCancel={() => setPreviewOpen(false)}
              footer={null}
              centered
              width={800}
            >
              {previewImage?.endsWith('.jpg') ||
              previewImage?.endsWith('.jpeg') ||
              previewImage?.endsWith('.png') ||
              previewImage?.endsWith('.webp') ? (
                <img src={previewImage} alt='Preview' />
              ) : (
                <iframe
                  src={`https://docs.google.com/gview?url=${previewImage}&embedded=true`}
                  style={{ width: '100%', height: '600px', border: 'none' }}
                  title='Document Preview'
                />
              )}
            </Modal>
          </Form.Item>
          {finishedData?.rc?.[0]?.status == 1 || finishedData?.rs == 0 ? (
            <Form.Item className='text-center'>
              <Button type='primary' htmlType='submit' disabled={isLoading}>
                Upload Documents
              </Button>
            </Form.Item>
          ) : (
            ''
          )}
        </Form>
      ) : (
        <div
          className='text-center'
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '16px',
          }}
        >
          No access permission
        </div>
      )}
    </Fragment>
  );
};
